import { DEFAULT_AUTH_DOMAIN, LMS_DOMAIN } from "@/lib/course/utils/constants";
import { getEnv } from "@/env";
import { DEFAULT_AUTH_MODE } from "@/hooks/useAuthBaseURL";

export const getInternalTrackSelectionDestinationUrl = (
  courseRunKey: string,
  category?: string,
  courseSlug?: string,
  emailOptIn?: boolean,
) => {
  const SITE_DOMAIN = getEnv("NEXT_PUBLIC_SITE_URL", "https://www.edx.org"); // Current domain
  return `${SITE_DOMAIN}/track-select/${category}/${courseSlug}/?emailOptIn=${emailOptIn}&courseRunKey=${courseRunKey}`;
};

const getTrackSelectionUrl = ({
  courseRunKey,
  category,
  courseSlug,
  useNewTrackSelect,
  emailOptIn,
  authBaseUrl,
  isUserLoggedIn,
  byPassAuth = false,
}: {
  courseRunKey: string;
  category?: string;
  courseSlug?: string;
  useNewTrackSelect?: string | boolean;
  emailOptIn?: boolean;
  authBaseUrl?: string;
  isUserLoggedIn?: boolean;
  byPassAuth?: boolean;
}) => {
  if (useNewTrackSelect === true || useNewTrackSelect === "true") {
    const destinationUrl = getInternalTrackSelectionDestinationUrl(
      courseRunKey,
      category,
      courseSlug,
      emailOptIn,
    );
    if (isUserLoggedIn || byPassAuth) {
      return destinationUrl;
    }
    const AUTH_DOMAIN =
      getEnv("NEXT_PUBLIC_AUTH_DOMAIN") ?? DEFAULT_AUTH_DOMAIN; // Current domain
    return new URL(
      `${DEFAULT_AUTH_MODE}?next=${encodeURIComponent(destinationUrl)}`,
      authBaseUrl ?? AUTH_DOMAIN,
    ).toString();
  }

  const trackSelectionUrl = `${LMS_DOMAIN}/course_modes/choose/`;
  return `${trackSelectionUrl}${encodeURIComponent(courseRunKey)}`;
};

export default getTrackSelectionUrl;
